<template>
  <Wrap
    id="article"
    class="author-articles-list obs-el"
    data-attr="article"
  >
    <slot />
  </Wrap>
</template>

<script lang="ts" setup>
  import Wrap from '@/shared/ui/Wrap.vue';
</script>

<style lang="scss" scoped>
  .author-articles-list {
    margin-top: var(--alias-space-56);

    @include tablet {
      margin-top: var(--alias-space-40);
    }
  }
</style>
